export function createPortalApiFetch(fetchImpl: typeof fetch = globalThis.fetch): typeof fetch {
  return (input, init) => {
    const headers = new Headers(init?.headers);
    const requestId = headers.get("X-Request-Id");
    headers.delete("X-Request-Id");
    if (requestId && !headers.has("X-Correlation-Id")) {
      headers.set("X-Correlation-Id", requestId);
    }
    return fetchImpl(input, { ...init, headers });
  };
}
